import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

export default function WorkModel() {
  return (
    <section className="relative overflow-hidden hpr-gradient text-white py-16 lg:py-24">
      <div className="pointer-events-none absolute -bottom-20 -right-10 w-[420px] h-[420px] rounded-full bg-white/5 blur-3xl" />
      <div className="mx-auto max-w-7xl px-6 grid lg:grid-cols-2 gap-12 items-center">
        <div className="reveal">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-[#8fb4ff]">Vår arbetsmodell</p>
          <h2 className="mt-3 text-3xl sm:text-5xl font-extrabold leading-tight">
            Vi sköter allt.<br /><span className="text-[#38BDF8]">Det blir enklare så.</span>
          </h2>
          <p className="mt-6 text-lg text-white/80 max-w-lg">
            Få raka besked, snabb återkoppling och ett tak som håller – helt utan mellanhänder.
            Från första besiktning till färdigt jobb är det alltid våra egna proffs som ansvarar.
          </p>
          <div className="mt-8 grid grid-cols-3 gap-6">
            {[["100%", "Egna team"], ["1 dag", "Snabb återkoppling"], ["10 år", "Garanti på målning"]].map(([v, l]) => (
              <div key={l}>
                <p className="text-3xl font-extrabold font-display">{v}</p>
                <p className="text-sm text-white/70">{l}</p>
              </div>
            ))}
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <Button asChild className="rounded-full h-13 px-7 py-3 bg-[#ffffff] text-[#1B45C4] hover:bg-[#e6edff] font-semibold">
              <a href="#kontakt">Få kostnadsfri offert <ArrowRight className="ml-2 w-5 h-5" /></a>
            </Button>
            <Button asChild variant="outline" className="rounded-full h-13 px-7 py-3 border-2 border-white/40 text-white hover:bg-white/10 font-semibold bg-transparent">
              <a href="#takkoll">Boka kostnadsfri TakKoll</a>
            </Button>
          </div>
        </div>
        <div className="reveal grid grid-cols-2 gap-4">
          <img src="https://images.unsplash.com/photo-1635424824800-692767998d07" alt="Takproffs på tak" className="rounded-2xl h-64 w-full object-cover shadow-2xl mt-8" />
          <img src="https://images.pexels.com/photos/18072935/pexels-photo-18072935.jpeg" alt="Skandinavisk villa" className="rounded-2xl h-64 w-full object-cover shadow-2xl" />
        </div>
      </div>
    </section>
  );
}
